var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasItems
    ? _c(
        "div",
        { staticClass: "d-flex flex-wrap media-list media-attachment" },
        _vm._l(this.value, function (item) {
          return _c(
            "div",
            {
              staticClass:
                "media-list__item media-attachment__thumbnails border border-gray-200",
            },
            [
              _c(_vm.getMediaComponent(item), {
                key: item.id,
                tag: "component",
                attrs: { item: item },
                nativeOn: {
                  click: function ($event) {
                    return _vm.preview(item)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "media-list__item-remove",
                  on: {
                    click: function ($event) {
                      return _vm.remove(item)
                    },
                  },
                },
                [_c("i", { staticClass: "fas fa-times-circle" })]
              ),
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }